import { useContext, useEffect } from "react";
import { SessionContext } from "../../context/SessionContext";

// Count players so closing an overlay cannot expose Compass over a live player.
export default function usePlaybackActivity() {
  const { setActivePlayerCount } = useContext(SessionContext) || {};
  useEffect(() => {
    if (!setActivePlayerCount) return;
    setActivePlayerCount((count) => count + 1);
    return () => setActivePlayerCount((count) => Math.max(0, count - 1));
  }, [setActivePlayerCount]);
}
